export const init = () => {
  if (tc_vars.env_template !== 'product') return;

  const fwk = CUBE.Analytics;

  let lockAddPanoply = false;
  /**
   * ENHANCED E-COMMERCE for ADD PANOPLY
   *
   */

  // > LOGIN (Virtual Page)
  const addPanoplyVirtualDetail = fwk.utils.getEvent(
    'addPanoplyVirtualDetail',
    AnalyticsConstants.trackers.product.addPanoply.name
  );
  if (addPanoplyVirtualDetail) {
    addPanoplyVirtualDetail.stopEvent = function() {
      if (this.triggerVirtual) this.triggerVirtual();
      return true;
    };
    addPanoplyVirtualDetail.triggerVirtual = () => {
      if (!lockAddPanoply) triggerVirtualPage();
      lockAddPanoply = true;
    };
  }

  /**
   * VIRTUAL PAGE METHOD
   */
  const triggerVirtualPage = () => {
    const frame = window.frames['virtual-page'];
    const urlPage = '/assets/virtual.html';

    frame.src = `${urlPage}?add_panoply=1`;
  };
};



// WEBPACK FOOTER //
// ./src/analytics/enhanced/ec-add-panoply.js